import React, { useEffect, useRef, useState } from 'react'
import SearchIcon from '../icons/SearchIcon';
import LocationArrowIcon from '../icons/LocationArrowIcon';
import { debounce } from 'lodash';
import { Coordinates } from '../../types/address';
import { fetchPlaces } from 'services/api/address';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface SearchSectionProps {
    currentGeolocation: Coordinates,
    onPlaceSelection: (place: any) => void,
    onCancel: () => void
}

const SearchSection: React.FC<SearchSectionProps> = ({ onCancel, currentGeolocation, onPlaceSelection }) => {

    const searchBoxRef = useRef<HTMLInputElement | null>(null);
    const hubId = useSelector((state: RootState) => state.auth.selectedHubId);
    const [suggestions, setSuggestions] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedPlace, setSelectedPlace] = useState<any>(null);

    const _loadPlaces = (query: string, callback: (places: any[]) => void) => {
        if (!query || query.length < 3 || !hubId) return callback([]);
        fetchPlaces(hubId, query, currentGeolocation).then((places: any[]) => {
            callback(places);
        }).catch((err) => console.log(err))
    };

    const loadPlaces = useRef(debounce(_loadPlaces, 500)).current;

    useEffect(() => {
        searchBoxRef.current?.focus();
    }, [])


    useEffect(() => {
        if(!searchQuery) return setSuggestions([]);

        loadPlaces(searchQuery, (places: any[]) => {
            setSuggestions(places);
        });
    }, [searchQuery]);

    useEffect(() => {
        if(selectedPlace){
            onPlaceSelection(selectedPlace);
        }
    }, [selectedPlace])

    return (
        <div className="search-place mb-5">
            <div className="search-wrapper pb-0">
                <div className="search-container">
                    <input
                        ref={searchBoxRef}
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search a building, street name or area"
                        className="search-input"
                    />
                    <span className="search-icon-place"><SearchIcon /></span>
                </div>
            </div>
            {/* <div className="action-btns">
                <div className="address-action-btn" onClick={() => onCancel()}>
                    <LocationArrowIcon />
                    Use my current location
                </div>
            </div> */}
            <div className="location-list">
                <span className="location-list-title">Search Result</span>
                {
                    suggestions.map((suggestion, i) => {
                        return (
                            <div className="location-list-item cursor-pointer" onClick={() => setSelectedPlace(suggestion)} key={i} >
                                <div className="location-list-item-top">
                                    <LocationArrowIcon />
                                    <span className="location-list-item-title">
                                        {suggestion.placePrediction?.structuredFormat?.mainText?.text}
                                    </span>
                                </div>
                                <span className="location-list-item-address">
                                    {suggestion.placePrediction?.structuredFormat?.secondaryText?.text}
                                </span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SearchSection